<div *ngIf="showSpinner">
  <div class="d-flex justify-content-center align-items-center">
    <span class="sr-onluy">Carregando...</span>
    <div class="spinner-border text-primary" role="status"></div>
  </div>
</div>


<!-- w-100 d-flex justify-content-center align-items-center  -->
